import { apiRequest } from '../lib/api.js';
import { aparelhoLocal, registrarAparelho } from '../lib/app-bridge.js';
import { escapeHtml } from '../lib/html.js';
import { showToast } from './toast.js';

const TIPOS = [
  ['paga', 'Venda paga', 'Quando o pedido fica pago.'],
  ['cancelada', 'Venda cancelada', 'Quando um pedido é cancelado.'],
  ['reembolso', 'Reembolso', 'Quando a Shopify registra um reembolso.'],
];

const TIPO_LABEL = {
  ...Object.fromEntries(TIPOS.map(([id, label]) => [id, label])),
  teste: 'Teste',
};

const ABAS = [
  ['prefs', 'Preferências'],
  ['teste', 'Teste'],
];

const EVENTOS = [
  ['venda', 'Teste de venda', 'Venda aprovada', 'Vendas', 'pedidos', 'ok', '+'],
  ['nova', 'Teste de nova venda', 'Nova venda', 'Novas vendas', 'pedidos', 'ok', '+'],
  ['recusa', 'Teste de recusa', 'Venda recusada', 'Recusas', 'pedidos', 'bad', ''],
  ['devolucao', 'Teste de devolução', 'Devolução', 'Devoluções', 'devoluções', 'bad', '−'],
  ['infracao', 'Teste de infração', 'Infração', 'Infrações', 'infrações', 'warn', '−'],
];

const AMOSTRAS = [
  ['Mentoria Escala Digital', 497],
  ['Curso Gestão de Tráfego', 197],
  ['E-book Copy Master', 47],
  ['Assinatura Club Elysium', 67],
  ['Template Pack Criativos', 37],
];

const ICONS = {
  ok: '<path d="M20 6 9 17l-5-5"/>',
  bad: '<path d="M18 6 6 18M6 6l12 12"/>',
  back: '<path d="M9 14 4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3"/>',
  warn: '<path d="M12 9v4M12 17h.01"/><path d="M10.3 4.8 2.6 18a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 4.8a2 2 0 0 0-3.4 0z"/>',
};

let doc = null;
let loaded = false;
let loading = false;
let loadError = '';
let syncAparelho = null;
let aba = 'prefs';
let destino = 'site';
let evento = 'venda';
let bound = false;
let aoMudar = null;
let puxando = null;
let enviando = false;
const vistos = new Set();

async function carregar() {
  loading = true;
  loadError = '';
  try {
    const data = await apiRequest('/integrations/notificacoes');
    doc = data?.data || null;
    for (const item of doc?.avisos || []) vistos.add(item.id);
    loaded = true;
  } catch (err) {
    loadError = err.message || 'Não foi possível carregar as notificações.';
  } finally {
    loading = false;
  }
}

function dinheiro(aviso) {
  if (aviso.total == null || aviso.total === '') return '';
  const total = Number(aviso.total);
  if (!Number.isFinite(total)) return '';
  try {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: aviso.currency || 'BRL' }).format(total);
  } catch {
    return `${total} ${aviso.currency || ''}`.trim();
  }
}

function quando(iso) {
  if (!iso) return '';
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return '';
  return data.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

function tiposHtml() {
  const tipos = doc?.tipos || {};
  return TIPOS.map(([id, label, texto]) => {
    const on = tipos[id] !== false;
    return `<div class="trk-row">
      <div>
        <div class="cell-title">${escapeHtml(label)}</div>
        <div class="cell-sub">${escapeHtml(texto)}</div>
      </div>
      <button type="button" class="g2-toggle ${on ? 'on' : ''}" data-aviso="tipo" data-v="${id}" role="switch" aria-checked="${on}" aria-label="${escapeHtml(label)}"><i></i></button>
    </div>`;
  }).join('');
}

function plataformaNome(valor) {
  const texto = String(valor || 'ios').toLowerCase();
  if (texto === 'ios') return 'iOS';
  if (texto === 'android') return 'Android';
  return valor || 'iOS';
}

function dispositivosHtml() {
  const lista = doc?.dispositivos || [];
  if (!lista.length) {
    return `<p class="avisos-vazio">Nenhum celular cadastrado. Abra o app, entre na conta, e ele aparece aqui.</p>`;
  }
  return `<ul class="avisos-devices">${lista.map((item) => `<li>
    <i aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2.5" width="10" height="19" rx="2"/><path d="M11 18.5h2"/></svg></i>
    <span><b>${escapeHtml(item.nome || 'iPhone')}</b><small>${escapeHtml(plataformaNome(item.plataforma))} · ${escapeHtml(quando(item.criadoEm) || 'cadastrado')}</small></span>
  </li>`).join('')}</ul>`;
}

function avisosHtml() {
  const lista = doc?.avisos || [];
  if (!lista.length) {
    return `<p class="avisos-vazio">Nenhum aviso ainda. Venda paga, cancelada e reembolso do mesmo tipo, em 3 segundos, saem juntos com o valor somado.</p>`;
  }
  return `<ul class="avisos-feed">${lista.map((item) => {
    const agrupado = Number(item.quantidade) > 1;
    const conhecido = TIPO_LABEL[item.tipo];
    const titulo = (agrupado || !conhecido) && item.orderName
      ? item.orderName
      : `${conhecido || item.tipo} ${item.orderName || ''}`.trim();
    const meta = [agrupado ? '' : (item.detalhe || item.lojaNome), item.canalNome].filter(Boolean).join(' · ');
    const valor = dinheiro(item);
    const hora = quando(item.criadoEm);
    return `<li>
      <div>
        <div class="avisos-titulo">${escapeHtml(titulo)}</div>
        ${meta ? `<div class="avisos-meta">${escapeHtml(meta)}</div>` : ''}
      </div>
      <div class="avisos-lado">
        ${valor ? `<b>${escapeHtml(valor)}</b>` : ''}
        ${hora ? `<small>${escapeHtml(hora)}</small>` : ''}
      </div>
    </li>`;
  }).join('')}</ul>`;
}

function abasHtml() {
  return `<div class="fat-toggle" role="tablist" aria-label="Notificações">
    ${ABAS.map(([id, label]) => `<button type="button" class="pill-btn ${aba === id ? 'on' : ''}" data-aviso="aba" data-v="${id}" aria-selected="${aba === id}">${label}</button>`).join('')}
  </div>`;
}

function destinos() {
  const atual = aparelhoLocal();
  const lista = [];
  if (atual) {
    lista.push({
      id: atual.id || '',
      nome: 'Este iPhone',
      detalhe: atual.nome || 'ios',
    });
  } else {
    lista.push({ id: 'site', nome: 'Este site', detalhe: 'O navegador em que você está logado' });
  }
  for (const item of doc?.dispositivos || []) {
    if (atual?.id && item.id === atual.id) {
      lista[0] = {
        id: item.id,
        nome: 'Este iPhone',
        detalhe: item.nome || item.plataforma || 'ios',
      };
      continue;
    }
    lista.push({
      id: item.id,
      nome: item.nome || 'iPhone',
      detalhe: item.plataforma || 'ios',
    });
  }
  return lista.filter((item) => item.id);
}

function painelTeste() {
  const noCelular = Boolean(aparelhoLocal());
  const opcoes = destinos();
  if (!opcoes.some((item) => item.id === destino)) destino = opcoes[0]?.id || (noCelular ? '' : 'site');
  if (!EVENTOS.some(([id]) => id === evento)) evento = 'venda';
  const avisoLista = noCelular
    ? (opcoes.length ? '' : '<p class="cell-sub" style="margin-top:12px">Cadastrando este iPhone…</p>')
    : ((doc?.dispositivos || []).length ? '' : '<p class="cell-sub" style="margin-top:12px">Nenhum celular cadastrado. Abra o app no iPhone e entre na conta para ele aparecer aqui.</p>');
  return `
    <div>
      <h3 class="card-title">Canal de teste</h3>
      <p class="cell-sub">${noCelular
        ? 'O teste sai neste iPhone. Venda, pedido novo, recusa, devolução e infração que chegarem juntos, em 3 segundos, saem num aviso só, com a soma.'
        : 'O envio entra no agrupador. Venda, pedido novo, recusa, devolução e infração que chegarem juntos, em 3 segundos, saem num aviso só, com a soma.'}</p>
      <div class="field-row" style="margin-top:12px">
        <div class="field">
          <label>Teste</label>
          <select data-aviso="evento">
            ${EVENTOS.map(([id, label]) => `<option value="${id}" ${id === evento ? 'selected' : ''}>${escapeHtml(label)}</option>`).join('')}
          </select>
        </div>
        <div class="field">
          <label>Dispositivo</label>
          <select data-aviso="destino" ${opcoes.length ? '' : 'disabled'}>
            ${opcoes.map((item) => `<option value="${escapeHtml(item.id)}" ${item.id === destino ? 'selected' : ''}>${escapeHtml(item.nome)}</option>`).join('')}
          </select>
        </div>
      </div>
      <button type="button" class="btn btn-primary" data-aviso="enviar" style="margin-top:12px" ${opcoes.length ? '' : 'disabled'}>Enviar teste</button>
      ${loadError ? `<p class="cell-sub" style="margin-top:12px">${escapeHtml(loadError)}</p>` : avisoLista}
    </div>`;
}

function amostra() {
  const item = AMOSTRAS[Math.floor(Math.random() * AMOSTRAS.length)];
  return { produto: item[0], valor: item[1] };
}

function reais(valor, currency) {
  const total = Number(valor);
  if (!Number.isFinite(total)) return '';
  try {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || 'BRL' }).format(total);
  } catch {
    return String(total);
  }
}

function specDe(eventoId) {
  return EVENTOS.find(([id]) => id === eventoId) || EVENTOS[0];
}

function caixaToasts() {
  let box = document.querySelector('.live-toasts');
  if (!box) {
    box = document.createElement('div');
    box.className = 'live-toasts';
    document.body.appendChild(box);
  }
  return box;
}

function mostrarAviso(aviso) {
  if (aviso.canal && aviso.canal !== 'site') return;
  const tipo = aviso.tipo || 'venda';
  const visual = { paga: 'venda', cancelada: 'recusa', reembolso: 'devolucao' }[tipo] || tipo;
  const [, , um, , , tom, sinal] = specDe(visual);
  const n = Number(aviso.quantidade) || 1;
  const icone = tom === 'warn' ? ICONS.warn : (visual === 'devolucao' ? ICONS.back : ICONS[tom] || ICONS.ok);
  const card = document.createElement('div');
  card.className = `live-toast ${tom}`;
  const titulo = aviso.orderName || um;
  const detalhe = n > 1 ? (aviso.lojaNome || '') : (aviso.detalhe || aviso.lojaNome || '');
  const valorTxt = reais(aviso.total, aviso.currency);
  const valor = valorTxt ? (sinal ? `${sinal} ${valorTxt}` : valorTxt) : '';
  card.innerHTML = `<div class="live-toast-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">${icone}</svg></div>`
    + `<div class="live-toast-body"><b>${escapeHtml(titulo)}</b><span>${escapeHtml(detalhe)}</span></div>`
    + `<div class="live-toast-val">${escapeHtml(valor)}</div>`;
  caixaToasts().appendChild(card);
  setTimeout(() => card.classList.add('out'), 3000);
  setTimeout(() => card.remove(), 3600);
}

function puxarAgrupados() {
  if (puxando) return puxando;
  puxando = (async () => {
    try {
      const data = await apiRequest('/integrations/notificacoes');
      const proximo = data?.data || null;
      const novos = (proximo?.avisos || []).filter((item) => item.id && !vistos.has(item.id));
      doc = proximo;
      for (const item of doc?.avisos || []) vistos.add(item.id);
      for (const aviso of novos) mostrarAviso(aviso);
      if (novos.length) aoMudar?.();
    } catch (err) {
      showToast(err.message || 'Não foi possível atualizar os avisos.');
    } finally {
      puxando = null;
    }
  })();
  return puxando;
}

function garantirAparelho() {
  if (!aparelhoLocal() || syncAparelho) return;
  syncAparelho = registrarAparelho()
    .then(async (data) => {
      if (Array.isArray(data?.dispositivos)) {
        doc = { ...(doc || { tipos: {}, avisos: [] }), dispositivos: data.dispositivos };
      }
      loaded = false;
      await carregar();
      aoMudar?.();
    })
    .catch((err) => {
      loadError = err.message || 'Não foi possível cadastrar este iPhone.';
      loaded = true;
      aoMudar?.();
    });
}

export function renderNotificacoes() {
  garantirAparelho();
  if (!loaded && !loading && !loadError) {
    loading = true;
    carregar().then(() => document.dispatchEvent(new CustomEvent('torre:notificacoes-ready')));
  }
  if (!loaded) {
    return `<div class="empty-state">${loadError ? escapeHtml(loadError) : 'Carregando notificações…'}</div>`;
  }
  const nAvisos = (doc?.avisos || []).length;
  const corpo = aba === 'teste'
    ? `<section class="g-card avisos-card avisos-teste">${painelTeste()}</section>`
    : `
    <div class="avisos-top">
      <section class="g-card avisos-card">
        <h3 class="card-title">O que avisar</h3>
        <p class="cell-sub">Vale para todos os celulares desta conta. O que chegar do mesmo tipo em 3 segundos vira um aviso, com a soma.</p>
        ${tiposHtml()}
      </section>
      <section class="g-card avisos-card">
        <h3 class="card-title">Dispositivos</h3>
        <p class="cell-sub">Celulares que recebem o mesmo aviso desta conta.</p>
        ${dispositivosHtml()}
      </section>
    </div>
    <section class="g-card avisos-card">
      <div class="card-head">
        <h3 class="card-title">Últimos avisos</h3>
        <span class="card-meta">${nAvisos} aviso${nAvisos === 1 ? '' : 's'}</span>
      </div>
      ${avisosHtml()}
    </section>`;
  return `<div class="avisos-page">${abasHtml()}${corpo}</div>`;
}

export function bindNotificacoes(onChange) {
  aoMudar = onChange;
  if (bound) return;
  bound = true;
  document.addEventListener('torre:notificacoes-ready', () => onChange?.());
  const root = document.getElementById('content');
  root.addEventListener('change', (event) => {
    const select = event.target.closest('[data-aviso="destino"], [data-aviso="evento"]');
    if (!select) return;
    if (select.dataset.aviso === 'evento') evento = select.value || 'venda';
    else destino = select.value || 'site';
  });
  root.addEventListener('click', async (event) => {
    const abaBtn = event.target.closest('[data-aviso="aba"]');
    if (abaBtn) {
      aba = abaBtn.dataset.v || 'prefs';
      onChange?.();
      return;
    }
    const enviar = event.target.closest('[data-aviso="enviar"]');
    if (enviar) {
      if (enviando) return;
      enviando = true;
      const item = amostra();
      const eventoAtual = evento;
      const destinoAtual = destino;
      const fim = () => { enviando = false; };
      apiRequest('/integrations/notificacoes/teste', {
        method: 'POST',
        body: JSON.stringify({
          destino: destinoAtual,
          evento: eventoAtual,
          detalhe: item.produto,
          total: item.valor,
        }),
      }).then(() => {
        setTimeout(() => {
          puxarAgrupados();
          fim();
        }, 3800);
      }).catch((err) => {
        fim();
        showToast(err.message || 'Não foi possível enviar o teste.');
      });
      return;
    }
    const btn = event.target.closest('[data-aviso="tipo"]');
    if (!btn || !doc) return;
    const id = btn.dataset.v;
    if (!TIPOS.some(([tipo]) => tipo === id)) return;
    const next = !(doc.tipos?.[id] !== false);
    doc.tipos = { ...(doc.tipos || {}), [id]: next };
    onChange?.();
    try {
      const data = await apiRequest('/integrations/notificacoes', {
        method: 'PUT',
        body: JSON.stringify({ tipos: doc.tipos }),
      });
      doc = data?.data || doc;
      showToast(next ? 'Aviso ligado.' : 'Aviso desligado.');
    } catch (err) {
      doc.tipos[id] = !next;
      showToast(err.message || 'Não foi possível salvar.');
    }
    onChange?.();
  });
}
